import React from 'react';
import './quantia.css';

/**
 * Badge / chip Quantia con la tipografía y tracking del style guide.
 *
 * Props:
 *  - variant: 'purple' | 'lime' | 'dark' | 'success' | 'warning' | 'danger' | 'info' | 'outline'
 *  - children: contenido (texto)
 *  - icon:    nodo opcional (emoji o icono pequeño) que se renderiza a la izquierda
 *  - sx:      estilos inline adicionales
 */
const Badge = ({
  variant = 'purple',
  children,
  icon,
  sx = {},
  className = '',
  ...rest
}) => {
  return (
    <span
      className={`qa-badge qa-badge--${variant} ${className}`}
      style={sx}
      {...rest}
    >
      {icon && <span className="qa-badge__icon">{icon}</span>}
      {children}
    </span>
  );
};

export default Badge;
